<template>
  <page-view title>
    <div slot="headerContent">
      <search-robot @changeRobotId="onChangeRobotId"></search-robot>
    </div>
    <exception-page type="norobot" v-if="!currentRobotId" />
    <a-card :bordered="false" v-if="currentRobotId">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="搜索条件">
                <a-select v-model="queryParam.search_condition" placeholder="请选择" allowClear>
                  <a-select-option value="1">微信群组ID</a-select-option>
                  <a-select-option value="2">群主微信昵称</a-select-option>
                  <a-select-option value="3">群名称</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="搜索关键字">
                <a-input v-model="queryParam.keywords" placeholder="请输入" />
              </a-form-item>
            </a-col>
            <template v-if="advanced"></template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator">
        <a-button type="primary" @click="$refs.addApplyGroupModal.show(currentRobotId)">新增返利群组</a-button>
        <a-popconfirm placement="top" @confirm="handleDeleteAll">
          <a-icon slot="icon" type="question-circle-o" style="color: red" />
          <template slot="title">
            <p>确定要删除？</p>
          </template>
          <a-button type="primary">删除所有返利群组</a-button>
        </a-popconfirm>
      </div>
      <s-table ref="table" rowKey="id" :columns="columns" :data="loadData">
        <span slot="serial" slot-scope="text">{{text}}</span>
        <span slot="nickname" slot-scope="text, record">
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ record.nickname }}</span>
            </template>
            <span v-line-clamp="1">{{ record.nickname || '无' }}</span>
          </a-tooltip>
        </span>
        <span slot="wxid" slot-scope="text, record">
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ record.wxid }}</span>
            </template>
            <span v-line-clamp="1">{{ record.wxid || '无' }}</span>
          </a-tooltip>
        </span>
        <span slot="remark" slot-scope="text, record">
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ record.remark }}</span>
            </template>
            <span v-line-clamp="1">{{ record.remark || '无' }}</span>
          </a-tooltip>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="$refs.groupUserListModal.show(currentRobotId,record.wxid)">群成员</a>
          <a-divider type="vertical" />
          <a @click="handleAddGroupUser(record)">新增群成员</a>
          <a-divider type="vertical" />
          <a @click="$refs.editApplyGroupModal.show(currentRobotId,record.wxid)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm placement="top" @confirm="handleDelete(record.id)">
            <a-icon slot="icon" type="question-circle-o" style="color: red" />
            <template slot="title">
              <p>确定要删除？</p>
            </template>
            <a>删除</a>
          </a-popconfirm>
        </span>
      </s-table>
      <edit-modal ref="editModal" @ok="$refs.table.refresh()"></edit-modal>
      <group-user-list-modal ref="groupUserListModal"></group-user-list-modal>
      <add-apply-group-modal ref="addApplyGroupModal" @ok="$refs.table.refresh()"></add-apply-group-modal>
      <edit-apply-group-modal ref="editApplyGroupModal" @ok="$refs.table.refresh()"></edit-apply-group-modal>
      <select-fans-modal ref="selectFansModal" @change="onChangeFans"></select-fans-modal>
    </a-card>
  </page-view>
</template>

<script>
import { STable } from '@/components'
import SearchRobot from '@/views/components/SearchRobot'
import GroupApi from '@/api/group'
import { PageView } from '@/layouts'
import { ExceptionPage } from '@/components'
import EditModal from './modules/EditModal'
import GroupUserListModal from './modules/GroupUserListModal'
import AddApplyGroupModal from './modules/AddApplyGroupModal'
import EditApplyGroupModal from './modules/EditApplyGroupModal'
import SelectFansModal from '@/views/components/SelectFansModal'
export default {
  name: 'UsergroupApplylist',
  components: {
    PageView,
    STable,
    SearchRobot,
    ExceptionPage,
    EditModal,
    GroupUserListModal,
    AddApplyGroupModal,
    EditApplyGroupModal,
    SelectFansModal
  },
  data() {
    return {
      currentRobotId: null,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: 'ID',
          width: '80px',
          dataIndex: 'id',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '群名称',
          width: '200px',
          scopedSlots: { customRender: 'nickname' }
        },
        {
          title: '微信群组ID',
          width: '300px',
          scopedSlots: { customRender: 'wxid' }
        },
        {
          title: '备注信息',
          scopedSlots: { customRender: 'remark' }
        },
        {
          title: '操作',
          width: '260px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return GroupApi.getApplyGroupList(
          Object.assign(parameter, this.queryParam, {
            sub_id: this.currentRobotId
          })
        )
      },
      currentChangeGroup: null
    }
  },
  filters: {
    getTypeTitle(type, types) {
      const arr = types.filter(val => {
        return val.id == type
      })
      return arr[0]['title']
    }
  },
  created() {},
  methods: {
    onChangeRobotId(id) {
      this.currentRobotId = id
      if (this.$refs.table) {
        this.$refs.table.refresh(true)
      }
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleDelete(id) {
      let loading = this.$message.loading('正在删除');
      GroupApi.deleteApplyGroup({ sub_id: this.currentRobotId,ids:[id] }).then((res)=>{
        if (res.code === 1) {
          this.$message.success("删除成功");
          this.$refs.table.refresh()
        } else {
          this.$message.error(res.msg);
        }
      }).finally(() => {
        this.$message.destroy(loading)
      })
    },
    handleDeleteAll() {
      let loading = this.$message.loading('正在删除');
      GroupApi.deleteApplyGroup({ sub_id: this.currentRobotId,all:1 }).then((res)=>{
        if (res.code === 1) {
          this.$message.success("删除成功");
          this.$refs.table.refresh()
        } else {
          this.$message.error(res.msg);
        }
      }).finally(() => {
        this.$message.destroy(loading)
      })
    },
    handleEdit(group_id) {
      const robot_id = this.currentRobotId
      this.$refs.editModal.show({})
    },
    handleAddGroupUser(data) {
      const robot_id = this.currentRobotId
      this.currentChangeGroup = data
      this.$refs.selectFansModal.show({ robotid: robot_id })
    },
    onChangeFans(data) {
      this.$refs.selectFansModal.handleCancel()
      const wxid = this.currentChangeGroup.wxid
      const group_name = this.currentChangeGroup.nickname
      const group_id = this.currentChangeGroup.id
      // let loading = this.$message.loading('正在操作');
      GroupApi.addGroupUser({ 
        sub_id: this.currentRobotId,
        wx_group_wx_id: wxid,
        wx_id: data.wxid,
        uid: data.uid,
        group_name: group_name,
        group_id: group_id,
        nickname: data.nickname,
        avatar: data.avatar,
        remark: ''
      }).then((res)=>{
        if (res.code === 1) {
          this.$message.success("操作成功");
          this.$refs.table.refresh()
        } else {
          this.$message.error(res.msg);
        }
      }).finally(() => {
        // this.$message.destroy(loading)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.table-operator {
  display: flex;
  flex-direction: row;
  align-items: center;
}
/deep/ .page-header {
  .extra {
    display: none;
  }
  .headerContent {
    flex: 0 1 100% !important;
  }
}
</style>
